import store from '../vuex/store';
import moment from "moment"
import Vue from 'vue';
/**
 * 判斷字符串或对象是否为空
 * @param name 需获取的参数名称
 */
export function isEmpty (params) {
  if(!params)
    return false
  if(typeof(params) == "string"){
    if (params == "" ) return true;
    var regu = "^[ ]+$";
    var re = new RegExp(regu);
    return re.test(params);
  }else if(typeof(params) == "object"){
    let empty = true
    for(let key in params){
      if(key){
        empty =false
        break
      }
    }
    return empty
  }
  return null;
}
export function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}
/**
 * 获取URL参数
 * @param name 需获取的参数名称
 */
export function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var search = window.location.href.indexOf("?") == -1 ? window.location.search : "?"+window.location.href.split("?")[1];
  var r = decodeURI(search).substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
/**
 *   获取权限公用方法
 *   @param currentCode 当前功能代码
 *   @param actionCode 动作代码
 */
export function getAuthority(currentCode,actionCode){
  let PermissionList = store.getters.getUserInfo.PermissionList,
    thisPermission = PermissionList.filter(item=>item.FunctionCode == currentCode)[0]
  if(!thisPermission)
    return false
  return thisPermission.ActionCodeList.indexOf(actionCode) != -1
}
Object.defineProperty(Vue.prototype, 'getAuthority', { value: getAuthority });
/**
 * 日期格式化
 * @param date 需要格式化的日期
 * @param format 格式化参数 YYYY-MM-DD HH:mm:ss
 */
export function formatDate(date, format) {
  if (!date) {
    return "";
  }
  format = format || "YYYY-MM-DD HH:mm:ss";
  date = date.replace("T"," ").replace("+08:00","");
  return moment(date).format(format);
}
Object.defineProperty(Vue.prototype, '$formatDate', { value: formatDate });
export function copyText(text, callback){ // text: 要复制的内容， callback: 回调
  var tag = document.createElement('input');
  tag.setAttribute('id', 'cp_hgz_input');
  tag.value = text;
  document.getElementsByTagName('body')[0].appendChild(tag);
  document.getElementById('cp_hgz_input').select();
  document.execCommand('copy');
  document.getElementById('cp_hgz_input').remove();
  if(callback) {callback(text)}
}

/**
 *   页面添加水印
 *   @param name 用户名
 *   @param department 部门
 */
window.addWaterMark = function(name,department,clientIP,waterMaskConfig) {
  var canvas = document.createElement("canvas");
  canvas.id = "watermark"
  document.body.className = "hasWaterMark"
  document.body.appendChild(canvas)
  var WaterMarkImg = document.getElementById("watermark"),
      WaterMarkContent = WaterMarkImg.getContext("2d"),
      ContentWidth = 1;
  if (department) {
    ContentWidth = department.length * 22;
    if (ContentWidth < 650){
      ContentWidth = 650;
    }
  }
  WaterMarkImg.width = ContentWidth;
  WaterMarkImg.height = ContentWidth / Math.sqrt(2);
  WaterMarkContent.save();
  WaterMarkContent.translate(0, 0);
  WaterMarkContent.rotate((Math.PI * -40) / 180);
  WaterMarkContent.font = "normal normal normal 18px/24px Microsoft YaHei";
  WaterMarkContent.fillStyle = waterMaskConfig.color||"#ddd";
 //添加姓名和时间
  WaterMarkContent.fillText(name, -WaterMarkImg.width / 2 + 350, WaterMarkImg.height / 2 + 50 + (24 * 1));
  WaterMarkContent.fillText(department, -WaterMarkImg.width / 2 + 350 , WaterMarkImg.height / 2 + 50 + (24 * 2));
  WaterMarkContent.fillText(moment().format("YYYY-MM-DD HH:mm:ss"), -WaterMarkImg.width / 2 + 350 , WaterMarkImg.height / 2 + 50 + (24 * 3));
  if(waterMaskConfig.showClientIP){
    WaterMarkContent.fillText(clientIP, -WaterMarkImg.width / 2 + 350 , WaterMarkImg.height / 2 + 50 + (24 * 4));
  }

  WaterMarkContent.fill();
  WaterMarkContent.restore();
  var WaterMarkBase64 = WaterMarkImg.toDataURL();
  WaterMarkImg.style.opacity = 0
  WaterMarkImg.style.pointerEvents = 'none'
  if (WaterMarkBase64.length > 20) {
    var div = document.createElement("div");
    div.id = "watermarkBox"
    div.className = 'watermarkBox'
    var background = "url('" + WaterMarkBase64 + "')";
    div.style.cssText = "width:"+ window.innerWidth+'px;height:'+window.innerHeight+'px;background:'+background+';position:fixed;top:0px;left:0px;pointer-events:none;opacity:'+(waterMaskConfig.opacity || 0.4)+';z-index:100000;'+""
    document.body.appendChild(div)
  }
}


// WEBPACK FOOTER //
// ./src/util/tools.js